import ActionTypes from '../constants/ActionTypes';

export function isFeaturedArticlesLoaded(state) {
  return !!(
    state.featuredArticles.status &&
    state.featuredArticles.status === ActionTypes.FETCH_FEATURED_ARTICLES_SUCCESS
  );
}
export function getFeaturedArticles(state) {
  return state.featuredArticles.list || [];
}
